<script>
    
    import State from '../stores/State.js'; 
    import { fade } from 'svelte/transition';

    function chooseLightning() {
        $State.prevChart = $State.selChart;
        $State.selChart = "Lightning";
    }
    function chooseFinish() {
        $State.prevChart = $State.selChart;
        $State.selChart = "Finish";
    }
    function choosePlaces() {
        $State.prevChart = $State.selChart;
        $State.selChart = "Places";
    }

</script>

<section id="chartNav">
    <div class="container" in:fade={{duration: $State.noFade ? 0 : 400}}>
            <div class="btnGroup {$State.selChart === "Lightning" ? 'selected' : ''}">
                <button class="btn btnLightning" on:click="{chooseLightning}"></button>
                <div class="btnText">Lightning Races</div>
            </div>
            <div class="btnGroup {$State.selChart === "Finish" ? 'selected' : ''}">
                <button class="btn btnFinish" on:click="{chooseFinish}"></button>
                <div class="btnText">Finish Traces</div>
            </div>
            <div class="btnGroup {$State.selChart === "Places" ? 'selected' : ''}">
                <button class="btn btnPlaces" on:click="{choosePlaces}"></button>
                <div class="btnText">Championship Places</div>
            </div>
    </div>
</section>

<style>
    .container {
	  max-width: 840px;
	  margin-top: 495px;
      display: flex;
      justify-content: space-between;
    }

   
   .btn {
        display: inline-block;
        margin-top: 15px;
        margin-bottom: 0;
        width: 30px;
        height: 30px;
        border-radius: 99px;
        border: 1px solid #343135;
        background-color: #00000000;
        box-shadow: -2px -2px 8px 0px #FFFFFF80, 2px 3px 8px 1px #000000;
        background-repeat: no-repeat;
        background-position: center;
        position: relative;
        -webkit-appearance: none;
    }
    
    .btnLightning {
        background-image: url('data:image/svg+xml;utf8,<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.5 1C9.5 1 4.0625 4 4.0625 4.5C4.0625 5 4.125 8.5 4.0625 9C4 9.5 1 13 1 13" stroke="%23999999" stroke-linecap="round"/><path d="M9.49957 1C9.49957 1 11.8746 4 11.9371 4.5C11.9996 5 11.9371 9 11.9371 9L10.9996 13" stroke="%23999999" stroke-linecap="round"/><path d="M9.5 1C9.5 1 6.625 4 6.3125 4.5C6 5 7 8.5 7 9C7 9.5 5 13 5 13" stroke="%23999999" stroke-linecap="round"/><path d="M9.5 1C9.5 1 9 4.5 9 5C9 5.5 11.9375 9 11.9375 9L15 13" stroke="%23999999" stroke-linecap="round"/></svg>');
    }    
    .selected .btnLightning {
        background-image: url('data:image/svg+xml;utf8,<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.5 1C9.5 1 4.0625 4 4.0625 4.5C4.0625 5 4.125 8.5 4.0625 9C4 9.5 1 13 1 13" stroke="%23FF3263" stroke-linecap="round"/><path d="M9.49957 1C9.49957 1 11.8746 4 11.9371 4.5C11.9996 5 11.9371 9 11.9371 9L10.9996 13" stroke="%23FF3263" stroke-linecap="round"/><path d="M9.5 1C9.5 1 6.625 4 6.3125 4.5C6 5 7 8.5 7 9C7 9.5 5 13 5 13" stroke="%23FF3263" stroke-linecap="round"/><path d="M9.5 1C9.5 1 9 4.5 9 5C9 5.5 11.9375 9 11.9375 9L15 13" stroke="%23FF3263" stroke-linecap="round"/></svg>');
    }
    
    .btnFinish {
        background-image: url('data:image/svg+xml;utf8,<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 1.5L15 1.5" stroke="%23999999"/><path d="M5 5.5L15 5.5" stroke="%23999999"/><path d="M0 9.5L15 9.5" stroke="%23999999"/></svg>');
    }

    .selected .btnFinish {
        background-image: url('data:image/svg+xml;utf8,<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 1.5L15 1.5" stroke="%23FF3263"/><path d="M5.5 5L15 5.5" stroke="%23FF3263"/><path d="M0 9.5L15 9.5" stroke="%23FF3263"/></svg>');
    }
    
    .btnPlaces {
        background-image: url('data:image/svg+xml;utf8,<svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 9H4" stroke="%23999999" stroke-width="2" stroke-dasharray="4 0.5"/><path d="M1 5H12" stroke="%23999999" stroke-width="2" stroke-dasharray="4 0.5"/><path d="M1 1H15" stroke="%23999999" stroke-width="2" stroke-dasharray="4 0.5"/></svg>');
    }   
    .selected .btnPlaces {
        background-image: url('data:image/svg+xml;utf8,<svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 9H4" stroke="%23FF3263" stroke-width="2" stroke-dasharray="4 0.5"/><path d="M1 5H12" stroke="%23FF3263" stroke-width="2" stroke-dasharray="4 0.5"/><path d="M1 1H15" stroke="%23FF3263" stroke-width="2" stroke-dasharray="4 0.5"/></svg>');
    }

    


    .btn:hover {
        box-shadow: -2px -2px 8px 0px #FFFFFF80, 2px 3px 8px 1px #000000, 0 0 0 2px #FF285D;
    }

    .btn:active, .selected .btn {
        box-shadow: inset 1px 2px 2px rgba(0, 0, 0, 0.8), inset -1px -1px 2px rgba(255, 255, 255, 0.5);
        background-color: #00000000;
    }

    .btnText {
        display: inline-block;
        height: 30px;
        line-height: 30px;
        vertical-align: bottom;
        margin-left: 10px;
        font-size: 14px;
        text-transform: uppercase;
        color: #F0B8C9;
        font-family: 'Poppins', 'Century Gothic', sans-serif;
    }

    .selected .btnText {
        color:#FF285D;
    }

    @media screen and (max-width: 600px) {
        .btnText{
            width: 90px;
            line-height: 16px;
        }
    }

    @media screen and (max-height: 770px) {
        .container {
            margin-top: 405px;
        }
    }

    @media screen and (max-height: 770px) and (max-width: 845px) {
        .container {
            margin-top: 440px;
        }
    }
</style>